export enum ParticipationQuestionTypeModel {
  YesNo = 0,
  FreeText = 1,
  SingleSelect = 2,
  MultiSelect = 3,
  AdditionalPersons = 4,
  HotelBooking = 5
}